/**
 * Constants used by the MapView component
 */

// LocalStorage key for persisting map view state
export const MAP_STORAGE_KEY = "mapViewState";
// LocalStorage key for persisting layer settings
export const LAYER_SETTINGS_STORAGE_KEY = "layerSettings";

// Long-press interaction constants
export const LONG_PRESS_MS = 550;
export const LONG_PRESS_INITIAL_DELAY_MS = 250; // Delay before starting the timer

// Movement thresholds for canceling long-press interactions
export const MOVE_CANCEL_PX = 8;

// Drag-to-insert waypoint constants
export const INSERT_LONG_PRESS_MS = 420;
export const INSERT_MOVE_START_PX = 5;

// Drag-to-move waypoint constants
export const MOVE_DRAG_START_PX = 4;

// Reachable area computation debounce delay
export const REACHABLE_COMPUTE_DEBOUNCE_MS = 500;
